module.exports = __webpack_public_path__ + "img/ethothy.727c5af3.png";